__turbopack_context__.v({
  "buttonWrapper": "NewAppStoreButton-module-scss-module__MEZUpa__buttonWrapper",
});
